/**
 * @file Route: productsingle
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "./index.scss";
import "layouts/main";
import { $, on } from "@olmokit/dom";
import { ProductSlider } from "components/Product/Slider";
import { bindCartBtnAdd } from "@olmokit/core/cart";
import { cartOn } from "@olmokit/core/cart";
import { globalConf, globalData } from "@olmokit/core/data";
import { updateCartSlider } from "components/Cart/Slide";
import { bindWishlistBtn } from "@olmokit/core/wishlist";
import { initWishlist, wishlistOn } from "@olmokit/core/wishlist";
import axios from 'axios';
import { ProductCard } from "components/Product/Card"

console.log("Route productsingle/index.js mounted.");

ProductSlider();
initWishlist();
bindWishlistBtn();
ProductCard();

wishlistOn("add:ok", (data) => {
  // dlAddWishlist();
  console.log('add:ok', data);
});

/**
 * Questo non va
 */
wishlistOn("remove:ok", (data) => {
  // dlAddWishlist();
  console.log('remove:ok', data);
});

/**
 * SET UP ECOMMERCE FUNCTION
 */
export function SetQuantity(value) {
  console.log('value', value);
  const $ProductAttribute = $('.productsingle');
  const cart = $ProductAttribute.getAttribute('data-item');
  let cartJson = JSON.parse(cart);
  cartJson['quantity'] = parseInt(value);
  cartJson = JSON.stringify(cartJson);
  const printCart = cartJson.replace(/\\/g, '').replace('"{', '{').replace('}"', '}');
  $ProductAttribute.setAttribute('data-item', printCart);  
}

export function ChangeInputSpin() {
  const $spinner = $('.spinner');
  const $inputSpin = $('.spinnerControl', $spinner);
  /**
  * Here you modify the object for the addCartButton
  */
  on($inputSpin, 'change', (event) => {        
    SetQuantity(event.target.value);
  });
  console.log('ChangeInputSpin active');
}

/**
 * Make things run
 */

bindCartBtnAdd();

cartOn("add:fail", (e) => {    
    if(e.response.status == 419){
        console.log('push something here',e);
        // const $error = $('.erorrs:quantity');
        // $error.style.display = 'block';
        // setTimeout(() => {
        // $error.style.display = 'none';
        // },3000);
    }
});

cartOn("add:ok", (e) => {
    const { response } = e;
    console.log("add:ok", response);

    // const myOffcanvas = $('#shoppingCart');
    // const bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas)
    // bsOffcanvas.show()
});

/**
 * Get the quantity from the api
 * 
 * @param type string product|item
 * @param id number
 */

const lang = globalConf.locale;
const cmsApiUrl = globalConf.cmsApiUrl;  

getQuantity('product', globalData.productsid);

function getQuantity(type, id) 
{
  const $container = $('.dataQuantity');
  const $spin = $('.count-input', $container);
  const $availability = $('.availability');
  const $cartButton = $('[data-cart-btn]', $container);
  $cartButton.disabled = true;
  $cartButton.setAttribute('disabled', 'true')
  $spin.style.pointerEvents = 'none';
  $spin.style.opacity = 0.2;
  $availability.style.display = 'none';
  
  axios.get(cmsApiUrl+"/"+lang+"/"+type+"/quantity/"+id, {
    headers: {
      'Content-Type': 'application/json',
      'front-token': 'a87sd8a7sydjas34123absjdb7$%dadsd'
    }
  })
  .then(e => {
    const { data } = e;
    
    const $spinnerControl = $('.spinnerControl');
    $spinnerControl.setAttribute('max', data.quantity);
    
    if(data.quantity > 0 && data.available){
      
      $cartButton.disabled = false;
      $availability.style.display = 'none';
      $spin.style.pointerEvents = 'inherit';
      $spin.style.opacity = 1;

      ChangeInputSpin();

    } else {

      console.log('outside', data.quantity, data.available);

      $cartButton.disabled = true;
      $availability.style.display = 'block';
      
      // const $spinnerQuantity = $('.Spinner:');
      // if($spinnerQuantity){
      //   $spinnerQuantity.remove();
      //   $productQuantity.innerHTML = $productQuantity.getAttribute('data-empty');
      // }

    }
  }).catch((error) => {
    $cartButton.disabled = true;
    $availability.style.display = 'block';    
  });
}

/**
 * Count input with increment (+) and decrement (-) buttons
 */

(() => {
  const countInputs = document.querySelectorAll('.count-input-prod');
  if (countInputs.length === 0) return;
  const handleIncrement = event => {
    const input = event.currentTarget.parentNode.querySelector('.form-control');
    const maxValue = parseInt(input.getAttribute('max')) || Infinity;
    if (input.value < maxValue) {
      input.value++;
      updateButtonStates(input);
      SetQuantity(input.value);
    }
  };
  const handleDecrement = event => {
    const input = event.currentTarget.parentNode.querySelector('.form-control');
    const minValue = parseInt(input.getAttribute('min')) || 0;
    if (input.value > minValue) {
      input.value--;
      updateButtonStates(input);
      SetQuantity(input.value);
    }
  };
  const updateButtonStates = input => {
    const decrementBtn = input.parentNode.querySelector('[data-decrement]');
    const incrementBtn = input.parentNode.querySelector('[data-increment]');
    const minValue = parseInt(input.getAttribute('min')) || 0;
    const maxValue = parseInt(input.getAttribute('max')) || Infinity;
    decrementBtn.disabled = input.value <= minValue;
    incrementBtn.disabled = input.value >= maxValue;
    const parent = input.closest('.count-input-prod');
    if (!parent.classList.contains('count-input-prod-collapsible')) return;
    const inputValue = incrementBtn.querySelector('[data-count-input-prod-value]');
    if (input.value > 0) {
      parent.classList.remove('collapsed');
      if (inputValue) {
        inputValue.textContent = input.value;          
      }
    } else {
      parent.classList.add('collapsed');
      if (inputValue) {
        inputValue.textContent = '';
      }
    }
  };
  countInputs.forEach(component => {
    const incrementBtn = component.querySelector('[data-increment]');
    const decrementBtn = component.querySelector('[data-decrement]');
    const input = component.querySelector('.form-control');
    incrementBtn.addEventListener('click', handleIncrement);
    decrementBtn.addEventListener('click', handleDecrement);
    updateButtonStates(input);
  });
})();